import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
const HeartEyesEmoji = ()=>{
    const $ = c(43);
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M15.9609 27.2849C22.1741 27.2849 27.2109 22.2481 27.2109 16.0349C27.2109 9.82171 22.1741 4.78491 15.9609 4.78491C9.74773 4.78491 4.71094 9.82171 4.71094 16.0349C4.71094 22.2481 9.74773 27.2849 15.9609 27.2849Z",
            fill: "url(#paint0_radial_10778_1060)"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M15.9609 27.2849C22.1741 27.2849 27.2109 22.2481 27.2109 16.0349C27.2109 9.82171 22.1741 4.78491 15.9609 4.78491C9.74773 4.78491 4.71094 9.82171 4.71094 16.0349C4.71094 22.2481 9.74773 27.2849 15.9609 27.2849Z",
            fill: "url(#paint1_radial_10778_1060)"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M15.9648 27.2539C22.178 27.2539 27.2148 22.2171 27.2148 16.0039C27.2148 9.7907 22.178 4.75391 15.9648 4.75391C9.75164 4.75391 4.71484 9.7907 4.71484 16.0039C4.71484 22.2171 9.75164 27.2539 15.9648 27.2539Z",
            fill: "url(#paint2_radial_10778_1060)",
            fillOpacity: "0.8"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M15.9648 4.75391C9.75164 4.75391 4.71485 9.7907 4.71485 16.0039C4.71485 22.2171 9.75164 27.2539 15.9648 27.2539C22.178 27.2539 27.2148 22.2171 27.2148 16.0039C27.2148 9.7907 22.1781 4.75391 15.9648 4.75391Z",
            fill: "url(#paint3_radial_10778_1060)",
            fillOpacity: "0.8"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx("g", {
            opacity: "0.4",
            filter: "url(#filter0_f_10778_1060)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M21.7421 8.45479C21.7421 10.0699 19.1765 11.3792 16.0117 11.3792C12.8468 11.3792 10.2812 10.0699 10.2812 8.45479C10.2812 6.83969 12.8468 5.5304 16.0117 5.5304C19.1765 5.5304 21.7421 6.83969 21.7421 8.45479Z",
                fill: "url(#paint4_radial_10778_1060)"
            })
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter1_f_10778_1060)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M20.1909 15.5176C16.7004 14.6379 16.9028 10.1147 17.5007 8.52291C19.1911 7.58062 24.9409 9.54573 25.8405 11.1459C26.6509 12.5874 22.9485 16.2126 20.1909 15.5176Z",
                fill: "url(#paint5_radial_10778_1060)"
            })
        });
        $[5] = t5;
    } else t5 = $[5];
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter2_f_10778_1060)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M11.9341 15.5176C15.4246 14.6379 15.2222 10.1147 14.6243 8.52291C12.9339 7.58062 7.1841 9.54573 6.2845 11.1459C5.4741 12.5874 9.17654 16.2126 11.9341 15.5176Z",
                fill: "url(#paint6_radial_10778_1060)"
            })
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M9.26788 15.9591C9.06994 15.8522 8.82516 15.9612 8.83218 16.186C8.89262 18.1232 10.8168 22.5064 15.9624 22.5064C21.2136 22.5064 23.2132 18.5337 23.1221 16.3724C23.113 16.1585 22.8806 16.0498 22.6864 16.1401C19.6898 17.5331 12.3628 17.63 9.26788 15.9591Z",
            fill: "#3F1C30"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.77951 15.556C8.99601 15.4491 9.25631 15.4558 9.47573 15.5742C10.9255 16.357 13.4414 16.7508 16.0158 16.7612C18.5869 16.7716 21.0909 16.3994 22.502 15.7435C22.7203 15.642 22.9683 15.6484 23.1725 15.7526C23.3838 15.8604 23.5474 16.0756 23.5592 16.3541C23.6598 18.7401 21.4858 22.944 15.9624 22.944C13.2487 22.944 11.3631 21.7819 10.1563 20.3553C8.96429 18.9461 8.42836 17.2724 8.3949 16.1998C8.38568 15.9042 8.55156 15.6685 8.77951 15.556ZM8.83218 16.1861C8.82517 15.9613 9.06994 15.8523 9.26788 15.9592C12.3628 17.6301 19.6898 17.5333 22.6864 16.1402C22.8806 16.05 23.113 16.1586 23.1221 16.3725C23.2133 18.5338 21.2136 22.5065 15.9624 22.5065C10.8168 22.5065 8.89262 18.1233 8.83218 16.1861Z",
            fill: "url(#paint7_linear_10778_1060)"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M19.4327 21.7964C19.1142 20.9809 17.6884 20.3665 15.9781 20.3665C14.3098 20.3665 12.9253 20.9459 12.5547 21.7253C13.4462 22.1848 14.5184 22.4807 15.7929 22.5048C15.8544 22.5058 15.9163 22.5063 15.9786 22.5064C17.3432 22.5043 18.4877 22.2337 19.4327 21.7964Z",
            fill: "url(#paint8_radial_10778_1060)"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M22.463 16.2521C22.463 17.0899 21.7931 19.0424 15.9987 19.0424C10.2038 19.0424 9.53516 16.9146 9.53516 16.2521C9.53516 16.1984 9.53653 16.1464 9.53924 16.0959C12.6919 17.5857 19.4299 17.4994 22.4629 16.2384C22.463 16.243 22.463 16.2476 22.463 16.2521Z",
            fill: "white"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M22.463 16.2521C22.463 17.0899 18.9326 17.6268 15.9987 17.6268C13.0649 17.6268 9.53516 16.9146 9.53516 16.2521C9.53516 16.1984 9.53653 16.1464 9.53924 16.0959C12.6919 17.5857 19.4299 17.4994 22.4629 16.2384C22.463 16.243 22.463 16.2476 22.463 16.2521Z",
            fill: "url(#paint9_radial_10778_1060)"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M13.3001 6.87802C12.0853 6.21394 10.3991 6.91703 9.85129 8.19483C8.85411 7.40435 6.87271 7.63144 6.20609 8.77887C5.66697 9.70679 5.30618 11.5178 7.25528 13.1634C8.87055 14.443 11.0389 15.3238 11.7131 15.1431C12.3872 14.9625 13.8247 13.1155 14.5838 11.1997C15.4489 8.80001 14.2418 7.39268 13.3001 6.87802Z",
            fill: "url(#paint10_linear_10778_1060)"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M13.3001 6.87802C12.0853 6.21394 10.3991 6.91703 9.85129 8.19483C8.85411 7.40435 6.87271 7.63144 6.20609 8.77887C5.66697 9.70679 5.30618 11.5178 7.25528 13.1634C8.87055 14.443 11.0389 15.3238 11.7131 15.1431C12.3872 14.9625 13.8247 13.1155 14.5838 11.1997C15.4489 8.80001 14.2418 7.39268 13.3001 6.87802Z",
            fill: "url(#paint11_radial_10778_1060)"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M13.3001 6.87802C12.0853 6.21394 10.3991 6.91703 9.85129 8.19483C8.85411 7.40435 6.87271 7.63144 6.20609 8.77887C5.66697 9.70679 5.30618 11.5178 7.25528 13.1634C8.87055 14.443 11.0389 15.3238 11.7131 15.1431C12.3872 14.9625 13.8247 13.1155 14.5838 11.1997C15.4489 8.80001 14.2418 7.39268 13.3001 6.87802Z",
            fill: "url(#paint12_radial_10778_1060)",
            fillOpacity: "0.7"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            opacity: "0.6",
            d: "M8.54568 12.0512C9.66474 11.7513 10.3288 10.6011 10.029 9.482C9.72914 8.36295 8.57889 7.69885 7.45983 7.9987C6.34077 8.29855 5.67667 9.4488 5.97652 10.5679C6.27637 11.6869 7.42663 12.351 8.54568 12.0512Z",
            fill: "url(#paint13_radial_10778_1060)"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            opacity: "0.9",
            d: "M12.2275 10.1086C12.999 9.90184 13.4568 9.10886 13.2501 8.33738C13.0434 7.56591 12.2504 7.10808 11.4789 7.31479C10.7074 7.52151 10.2496 8.31449 10.4563 9.08597C10.663 9.85744 11.456 10.3153 12.2275 10.1086Z",
            fill: "url(#paint14_radial_10778_1060)"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M18.6881 6.87802C19.903 6.21394 21.5891 6.91703 22.137 8.19483C23.1342 7.40435 25.1156 7.63144 25.7822 8.77887C26.3213 9.70679 26.6821 11.5178 24.733 13.1634C23.1177 14.443 20.9494 15.3238 20.2752 15.1431C19.6011 14.9625 18.1636 13.1155 17.4045 11.1997C16.5393 8.80001 17.7465 7.39268 18.6881 6.87802Z",
            fill: "url(#paint15_linear_10778_1060)"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M18.6881 6.87802C19.903 6.21394 21.5891 6.91703 22.137 8.19483C23.1342 7.40435 25.1156 7.63144 25.7822 8.77887C26.3213 9.70679 26.6821 11.5178 24.733 13.1634C23.1177 14.443 20.9494 15.3238 20.2752 15.1431C19.6011 14.9625 18.1636 13.1155 17.4045 11.1997C16.5393 8.80001 17.7465 7.39268 18.6881 6.87802Z",
            fill: "url(#paint16_radial_10778_1060)"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M18.6881 6.87802C19.903 6.21394 21.5891 6.91703 22.137 8.19483C23.1342 7.40435 25.1156 7.63144 25.7822 8.77887C26.3213 9.70679 26.6821 11.5178 24.733 13.1634C23.1177 14.443 20.9494 15.3238 20.2752 15.1431C19.6011 14.9625 18.1636 13.1155 17.4045 11.1997C16.5393 8.80001 17.7465 7.39268 18.6881 6.87802Z",
            fill: "url(#paint17_radial_10778_1060)",
            fillOpacity: "0.7"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            opacity: "0.9",
            d: "M19.6552 10.5105C18.6617 10.2443 18.0722 9.22317 18.3384 8.22972C18.6046 7.23627 19.6257 6.64672 20.6192 6.91291C21.6126 7.1791 22.2022 8.20025 21.936 9.1937C21.6698 10.1871 20.6486 10.7767 19.6552 10.5105Z",
            fill: "url(#paint18_radial_10778_1060)"
        });
        $[6] = t10;
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
        $[10] = t14;
        $[11] = t15;
        $[12] = t16;
        $[13] = t17;
        $[14] = t18;
        $[15] = t19;
        $[16] = t20;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else {
        t10 = $[6];
        t11 = $[7];
        t12 = $[8];
        t13 = $[9];
        t14 = $[10];
        t15 = $[11];
        t16 = $[12];
        t17 = $[13];
        t18 = $[14];
        t19 = $[15];
        t20 = $[16];
        t6 = $[17];
        t7 = $[18];
        t8 = $[19];
        t9 = $[20];
    }
    let t21;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_10778_1060",
            x: "7.44923",
            y: "2.69837",
            width: "17.125",
            height: "11.5129",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "1.41601",
                    result: "effect1_foregroundBlur_10778_1060"
                })
            ]
        });
        $[21] = t21;
    } else t21 = $[21];
    let t22;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsxs("filter", {
            id: "filter1_f_10778_1060",
            x: "16.5312",
            y: "7.65259",
            width: "10.0469",
            height: "8.57758",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.3125",
                    result: "effect1_foregroundBlur_10778_1060"
                })
            ]
        });
        $[22] = t22;
    } else t22 = $[22];
    let t23;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ jsxs("filter", {
            id: "filter2_f_10778_1060",
            x: "5.54688",
            y: "7.65259",
            width: "10.0469",
            height: "8.57758",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.3125",
                    result: "effect1_foregroundBlur_10778_1060"
                })
            ]
        });
        $[23] = t23;
    } else t23 = $[23];
    let t24;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.631 6.1309) scale(21.0305)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.43",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00"
                })
            ]
        });
        $[24] = t24;
    } else t24 = $[24];
    let t25;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(12.8919 18.2106 -18.2098 12.8488 10.8666 6.5542)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.608798",
                    stopColor: "#FFE437",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.858784",
                    stopColor: "#FF79B1",
                    stopOpacity: "0.45"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.994222",
                    stopColor: "#FF3673",
                    stopOpacity: "0.56"
                })
            ]
        });
        $[25] = t25;
    } else t25 = $[25];
    let t26;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.9648 16.5162) rotate(-90) scale(12.3762 11.8236)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.848958",
                    stopColor: "#FFC60C",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF7039",
                    stopOpacity: "0.68"
                })
            ]
        });
        $[26] = t26;
    } else t26 = $[26];
    let t27;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.9648 15.4916) rotate(90) scale(11.7623 11.6637)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.847356",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F11414",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[27] = t27;
    } else t27 = $[27];
    let t28;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.0117 8.45479) rotate(89.9999) scale(2.92439 5.37628)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFED49",
                    stopOpacity: "0"
                })
            ]
        });
        $[28] = t28;
    } else t28 = $[28];
    let t29;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.4278 11.428) rotate(30.8014) scale(6.87106 4.56986)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.377992",
                    stopColor: "#D75639"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFA637",
                    stopOpacity: "0"
                })
            ]
        });
        $[29] = t29;
    } else t29 = $[29];
    let t30;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint6_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.6972 11.428) rotate(149.199) scale(6.87106 4.56986)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.377992",
                    stopColor: "#D75639"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFA637",
                    stopOpacity: "0"
                })
            ]
        });
        $[30] = t30;
    } else t30 = $[30];
    let t31;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint7_linear_10778_1060",
            x1: "15.9785",
            y1: "15.9179",
            x2: "15.9785",
            y2: "22.5065",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FD9E28",
                    stopOpacity: "0.4"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFF2B7"
                })
            ]
        });
        $[31] = t31;
    } else t31 = $[31];
    let t32;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint8_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.9937 20.3665) rotate(90.0008) scale(2.34113 5.10971)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF7294"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.416498",
                    stopColor: "#FF71A4"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#EF164A"
                })
            ]
        });
        $[32] = t32;
    } else t32 = $[32];
    let t33;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint9_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-7.24217 0.127054 1.0938 -47.5637 16.1922 17.0903)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#C9C9C9"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D2D2D2",
                    stopOpacity: "0.6"
                })
            ]
        });
        $[33] = t33;
    } else t33 = $[33];
    let t34;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint10_linear_10778_1060",
            x1: "7.87086",
            y1: "8.37411",
            x2: "12.287",
            y2: "14.9782",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF4F37"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.42",
                    stopColor: "#EA002D"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D30D81"
                })
            ]
        });
        $[34] = t34;
    } else t34 = $[34];
    let t35;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint11_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.176 6.91069) rotate(131.362) scale(8.38912 8.38912)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.66",
                    stopColor: "#E20A26",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#C40000"
                })
            ]
        });
        $[35] = t35;
    } else t35 = $[35];
    let t36;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint12_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(5.36332 3.48616 -4.99536 7.7044 8.42893 9.91418)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.395833",
                    stopColor: "#FF4570",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.826596",
                    stopColor: "#C933CC",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F459AD"
                })
            ]
        });
        $[36] = t36;
    } else t36 = $[36];
    let t37;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t37 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint13_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(8.01359 9.97712) rotate(-15) scale(2.11063)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9999",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF0027",
                    stopOpacity: "0"
                })
            ]
        });
        $[37] = t37;
    } else t37 = $[37];
    let t38;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t38 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint14_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.923 8.70731) rotate(-15) scale(1.42678)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9999",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF1F1F",
                    stopOpacity: "0"
                })
            ]
        });
        $[38] = t38;
    } else t38 = $[38];
    let t39;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t39 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint15_linear_10778_1060",
            x1: "24.1174",
            y1: "8.37411",
            x2: "19.559",
            y2: "15.024",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF4F37"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.42",
                    stopColor: "#EA002D"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D30D81"
                })
            ]
        });
        $[39] = t39;
    } else t39 = $[39];
    let t40;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t40 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint16_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(21.3301 7.96116) rotate(54.0757) scale(6.7069 6.7069)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.66",
                    stopColor: "#E20A26",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#C40000"
                })
            ]
        });
        $[40] = t40;
    } else t40 = $[40];
    let t41;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t41 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint17_radial_10778_1060",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(3.25067 6.62341 9.51279 -4.65526 19.2924 8.00925)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.395833",
                    stopColor: "#FF4570",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.796239",
                    stopColor: "#C933CC",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F459AD"
                })
            ]
        });
        $[41] = t41;
    } else t41 = $[41];
    let t42;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t42 = /*#__PURE__*/ jsxs("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                /*#__PURE__*/ jsxs("defs", {
                    children: [
                        t21,
                        t22,
                        t23,
                        t24,
                        t25,
                        t26,
                        t27,
                        t28,
                        t29,
                        t30,
                        t31,
                        t32,
                        t33,
                        t34,
                        t35,
                        t36,
                        t37,
                        t38,
                        t39,
                        t40,
                        t41,
                        /*#__PURE__*/ jsxs("radialGradient", {
                            id: "paint18_radial_10778_1060",
                            cx: "0",
                            cy: "0",
                            r: "1",
                            gradientUnits: "userSpaceOnUse",
                            gradientTransform: "translate(20.0473 8.70609) rotate(-165) scale(1.8373)",
                            children: [
                                /*#__PURE__*/ jsx("stop", {
                                    stopColor: "#FF9999",
                                    stopOpacity: "0.6"
                                }),
                                /*#__PURE__*/ jsx("stop", {
                                    offset: "1",
                                    stopColor: "#FF1F1F",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
        $[42] = t42;
    } else t42 = $[42];
    return t42;
};
export { HeartEyesEmoji };
